import React from 'react'
import styled from 'styled-components'
import { defaultCTAURI } from 'src/modules/utils/constants'
import { fetchRSNs } from 'src/modules/utils/checkRSN'
import { rsnData } from 'src/modules/utils/checkRSN/data/rsnData'
import { replaceUrlParam } from 'src/modules/utils/replaceUrlParam'
import { createUrl } from 'src/modules/utils/createUrl'
import { useSelector } from 'react-redux'
import { selectCTAParams } from 'src/modules/reducers/params'
import CTAButton from 'src/components/common/CTAButtonNew'
import { fireUIInteractionEvent, fireUIRenderEvent } from 'src/modules/analytics/v3'
import { selectStateForProtobuf } from 'src/modules/reducers'
import { selectMarketState, selectPostalCode } from 'src/modules/reducers/market'
import { selectAnalyticsReady } from 'src/modules/reducers/analytics'
import { useCtaText } from 'src/modules/hooks/useCtaText'
import { colors, mediaQuery, spacing } from 'src/constants/marketing-ds'
import { BannerHeader } from '../SharedComponents'
// import { ScrollTrigger } from 'gsap/ScrollTrigger'

const RSNGeolocationBanner = ({
  ctaHrefOverride,
  ctaQuery,
  hasOfferInput,
  ctaText,
  rsnOverride,
  hidden,
  disableFreeTrial,
  lang,
  market,
}) => {
  const isAnalyticsReady = useSelector(selectAnalyticsReady)
  const postalCode = useSelector(selectPostalCode)
  const { regionCode } = useSelector(selectMarketState)

  const parsedParams = useSelector(selectCTAParams)
  let ctaURL = createUrl(defaultCTAURI, parsedParams)
  const stateForProtobuf = useSelector(selectStateForProtobuf)
  const [eligibleRSN, setEligibleRSN] = React.useState(null)

  const ctaTextCopy = useCtaText({ lang, market, disableFreeTrial, ctaText, isTextShort: true })

  // init location check and set RSN eligibility
  React.useEffect(() => {
    if (postalCode && regionCode && isAnalyticsReady) {
      fetchRSNs(postalCode, regionCode)
        .then(({ rsnList }) => {
          if (rsnList) {
            setEligibleRSN(rsnList)
            fireUIRenderEvent(
              {
                type: postalCode,
                component: 'rsn_only_banner',
              },
              stateForProtobuf
            )
          }
        })
        .catch((error) => console.error('Error fetching data:', error))
    }
  }, [postalCode, regionCode, isAnalyticsReady])

  const handleOnClick = (e) => {
    fireUIInteractionEvent(
      {
        element: eligibleRSN,
        component: 'rsn_geolocation_banner_cta_clicked',
        type: 'clicked',
      },
      stateForProtobuf
    )
  }

  ctaURL = replaceUrlParam(ctaURL, 'comp', 'rsnbanner')

  if (eligibleRSN && !hidden) {
    const RSNLogos = eligibleRSN
      .map((rsn, i) => {
        if (!rsnData?.[rsn]?.logo) return null

        const imgSrc = rsnData[rsn]?.logo + '?w=160&ch=width&auto=format,compress'
        return (
          <div className="banner-image" key={i}>
            <img src={imgSrc} alt={rsn} />
          </div>
        )
      })
      .filter((item) => item !== null && item !== undefined)

    if (RSNLogos.length > 0) {
      return (
        <StyledRSNGeolocationBanner>
          <div className="banner-content">
            <div className="banner-logos desktop-only">{RSNLogos}</div>

            <div className="banner-text">
              <BannerHeader title="Fubo has your local teams" variant="light" />
            </div>
            <CTAButton
              link={hasOfferInput ? '#' : ctaHrefOverride || ctaURL}
              onClick={handleOnClick}
              isOutlined={true}
            >
              {ctaTextCopy}
            </CTAButton>
          </div>
        </StyledRSNGeolocationBanner>
      )
    }
  }
  return null
}

export default RSNGeolocationBanner

const breakpoint = 768
const desktopBreak = breakpoint + 'px'
const mobileBreak = breakpoint - 1 + 'px'

const StyledRSNGeolocationBanner = styled.div`
  background: ${colors.slate[30]};
  width: 100%;
  z-index: 5;
  text-align: left;

  .banner-content {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
    max-width: 1460px;
    flex-direction: column;
    gap: ${spacing.md};
    padding: ${spacing.lg} ${spacing.xs};

    ${mediaQuery.tabletMax} {
      padding: ${spacing.lg} ${spacing.md};
      gap: ${spacing.lg};
      flex-direction: row;
    }

    .banner-text {
      flex: 0 0 auto;
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      ${mediaQuery.tabletMax} {
        order: 1;
      }
    }
    .banner-logos {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 7%;
      ${mediaQuery.tabletMax} {
        gap: 20px;
        order: 2;
        margin-bottom: 0;
      }

      .banner-image {
        flex: 0 1 auto;
        object-fit: contain;
        display: flex;
        align-items: center;
        justify-content: center;
        max-width: 115px;
        max-height: 50px;
        height: 47px;
        img {
          object-fit: contain;
          max-width: 100%;
          max-height: 100%;
        }
      }
    }
    .CTAButton {
      ${mediaQuery.tabletMax} {
        order: 3;
      }
    }

    .desktop-only {
      display: flex;
    }
  }
`
